(function () {
  'use strict';

  if (typeof window === 'undefined') return;

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var html = document.documentElement;

  function revealAll() {
    document.querySelectorAll('[data-cor-anim]').forEach(function (el) {
      el.classList.add('is-revealed');
    });
    document.querySelectorAll('[data-cor-anim-child], [data-cor-line], [data-cor-pin-row]').forEach(function (c) {
      c.classList.add('is-revealed');
    });
  }

  if (reduceMotion) {
    revealAll();
    return;
  }

  html.classList.add('cor-anim-armed');

  function revealEl(el) {
    el.classList.add('is-revealed');
    var type = el.getAttribute('data-cor-anim');
    var nested = el.querySelectorAll('[data-cor-anim-child], [data-cor-line], [data-cor-pin-row]');

    if (nested.length === 0) {
      if (type === 'fade-up') {
        var direct = el.children;
        for (var i = 0; i < direct.length; i++) {
          (function (child, idx) {
            window.setTimeout(function () { child.classList.add('is-revealed'); }, idx * 80);
          })(direct[i], i);
        }
      }
      return;
    }

    var staggerSec = parseFloat(el.getAttribute('data-cor-stagger') || '0.14');
    var staggerMs = Math.max(40, staggerSec * 1000);
    nested.forEach(function (child, idx) {
      window.setTimeout(function () { child.classList.add('is-revealed'); }, idx * staggerMs);
    });
  }

  function setupReveals() {
    var nodes = document.querySelectorAll('[data-cor-anim], [data-cor-pin]');
    if (nodes.length === 0) return;

    if (!('IntersectionObserver' in window)) {
      revealAll();
      return;
    }

    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        var el = entry.target;
        var type = el.getAttribute('data-cor-anim');
        if (type === 'hero-release') {
          io.unobserve(el);
          return;
        }
        revealEl(el);
        io.unobserve(el);
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });

    nodes.forEach(function (el) {
      var type = el.getAttribute('data-cor-anim');
      if (type === 'hero-release') return;
      io.observe(el);
    });
  }

  function safetyReveal() {
    document.querySelectorAll('[data-cor-anim]:not(.is-revealed), [data-cor-pin]:not(.is-revealed)').forEach(function (el) {
      var rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 1.6 && rect.bottom > -window.innerHeight * 0.2) {
        revealEl(el);
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupReveals);
  } else {
    setupReveals();
  }

  // a11y: focus must never land on still-hidden (opacity:0) content. Reveal the
  // container (and any gated child) the moment focus enters it, regardless of
  // whether the IntersectionObserver has intersected it yet.
  document.addEventListener('focusin', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    var host = target.closest('[data-cor-anim]:not(.is-revealed), [data-cor-pin]:not(.is-revealed)');
    if (host) revealEl(host);
    var child = target.closest('[data-cor-anim-child]:not(.is-revealed), [data-cor-line]:not(.is-revealed), [data-cor-pin-row]:not(.is-revealed)');
    if (child) child.classList.add('is-revealed');
  });

  window.addEventListener('load', function () {
    window.setTimeout(safetyReveal, 2500);
  });

  function loadScript(src) {
    return new Promise(function (resolve, reject) {
      var s = document.createElement('script');
      s.src = src;
      s.async = true;
      s.onload = function () { resolve(); };
      s.onerror = function () { reject(new Error('Failed: ' + src)); };
      document.head.appendChild(s);
    });
  }

  Promise.all([
    loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.7/dist/gsap.min.js'),
    loadScript('https://cdn.jsdelivr.net/npm/gsap@3.12.7/dist/ScrollTrigger.min.js')
  ]).then(function () {
    if (!window.gsap || !window.ScrollTrigger) return;
    window.gsap.registerPlugin(window.ScrollTrigger);
    initScrub();
  }).catch(function (err) {
    console.warn('[cor-scroll-motion] GSAP load failed, scrub effects skipped', err);
  });

  function initScrub() {
    var gsap = window.gsap;
    var ST = window.ScrollTrigger;

    document.querySelectorAll('[data-cor-parallax]').forEach(function (el) {
      var depth = parseFloat(el.getAttribute('data-cor-parallax') || '0.2');
      gsap.fromTo(el,
        { yPercent: -depth * 50 },
        {
          yPercent: depth * 50,
          ease: 'none',
          scrollTrigger: {
            trigger: el,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 0.5
          }
        }
      );
    });

    document.querySelectorAll('[data-cor-drift-x]').forEach(function (el) {
      var px = parseFloat(el.getAttribute('data-cor-drift-x') || '40');
      gsap.fromTo(el,
        { xPercent: -px / 4 },
        {
          xPercent: px / 4,
          ease: 'none',
          scrollTrigger: {
            trigger: el,
            start: 'top bottom',
            end: 'bottom top',
            scrub: 0.6
          }
        }
      );
    });

    document.querySelectorAll('[data-cor-anim="hero-release"]').forEach(function (el) {
      gsap.to(el, {
        scale: 1.08,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top top',
          end: 'center top',
          scrub: 1
        }
      });
    });

    requestAnimationFrame(function () { ST.refresh(); });

    var rt;
    window.addEventListener('resize', function () {
      window.clearTimeout(rt);
      rt = window.setTimeout(function () { ST.refresh(); }, 200);
    });
  }
})();
